export default "__VITE_ASSET__B9p_6SOk__"